export enum HeaderPlatformType {
  INTRO = 'INTRO',
  RESEARCH = 'RESEARCH',
  TOPIC = 'TOPIC',
  GUIDE = 'GUIDE',
}
